import { render, staticRenderFns } from "./WorkSpace.vue?vue&type=template&id=5c2ffbcf"
import script from "./WorkSpace.vue?vue&type=script&lang=js"
export * from "./WorkSpace.vue?vue&type=script&lang=js"
import style0 from "./WorkSpace.vue?vue&type=style&index=0&id=5c2ffbcf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports